import { PackagesGridView } from '../view/PackagesGridView';
import { PackageType } from '../types';

export class PackageActionEnabler {
  static handleActionButtons(view: PackagesGridView, selectedItems: Array<any>): void {
    let enableSendDownload = false;
    let enableDelete = false;
    let enableDownloadBtn = false;

    if (selectedItems.length === 1) {
      enableDownloadBtn = true;

      const item = selectedItems[0];
      if (item.type === PackageType.Endpoints) {
        enableSendDownload = true;
      }
    }

    //check for default packages
    //if default packages delete button should be disabled
    let hasDefault = false;
    for (const selection of selectedItems) {
      if (selection.default === true) {
        hasDefault = true;
        break;
      }
    }

    if (!hasDefault && selectedItems.length) {
      enableDelete = true;
    }

    if (selectedItems.length !== 1) {
      enableSendDownload = false;
      enableDownloadBtn = false;
    }

    view.enableDisableDelete(enableDelete);
    view.enableDisableSendDownload(enableSendDownload);
    view.enableDisableDownloadBtn(enableDownloadBtn);
  }
}
